import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import Question from 'on_web/components/shared/Question/Question';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import UserProfileContext from 'on_web/context/userProfileContext';

import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import Text from 'on_web/components/shared/Common/Text';

function DnaProviderSelection(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedItem, setSelectedItem] = useState(
    context && context.user_metadata && context.user_metadata.dnaProviders
      ? context.user_metadata.dnaProviders
      : undefined
  );

  const onClickNext = () => {
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata) {
      userMetadata.dnaProviders = selectedItem;
      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();
  const questions = [
    {
      checked: selectedItem === '1',
      value: '1',
      label: t('common.answers.23andMe'),
    },
    {
      checked: selectedItem === '2',
      value: '2',
      label: t('common.answers.ancestry'),
    },
    {
      checked: selectedItem === '3',
      value: '3',
      label: t('common.answers.familyTreeDna'),
    },
  ];

  return (
    <div>
      <Header />
      {props.forPce && <PceStepProgressIndicator selectedSlideIx={0} />}

      <Question
        sectionTitle={t(
          'onboarding.dnaSection.dnaProviderSelection.sectionTitle'
        )}
        radioSelection={{ items: questions }}
        onAnswer={val => setSelectedItem(val)}
        instructionAbove={t(
          'onboarding.dnaSection.dnaProviderSelection.instructionAbove'
        )}
      />
      <Box
        px={{ xs: 2.5, sm: 3, md: 4 }}
        style={{
          borderTop:
            props.showTopBorder === true ? '1px Solid #ececec' : 'none',
        }}
      >
        <Text variant="caption" display="block" gutterBottom>
          {t('onboarding.dnaSection.dnaProviderSelection.providerSupport')}
        </Text>
      </Box>

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={!selectedItem}
      />
    </div>
  );
}

export default DnaProviderSelection;
